import React, { useRef, useEffect } from 'react';

import { IconButtonProps } from './IconButton';
import StyledIconButton from './StyledIconButton';

const IconButton: React.FC<IconButtonProps> = ({
  noText,
  icon,
  alt,
  title,
  className,
  onClick,
  onBlur,
  width,
  focused,
}) => {
  const itemRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (focused && itemRef.current) {
      itemRef.current.focus();
    }
  }, [focused]);

  return (
    <StyledIconButton
      ref={itemRef}
      className={className}
      noText={noText}
      onClick={onClick}
      onBlur={onBlur}
      width={width}
    >
      <img className="icon" src={icon} alt={alt} />
      {title}
    </StyledIconButton>
  );
};

export default IconButton;
